import { render, staticRenderFns } from "./ObservationNewInfo.vue?vue&type=template&id=77156840&scoped=true&"
import script from "./ObservationNewInfo.vue?vue&type=script&lang=js&"
export * from "./ObservationNewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77156840",
  null
  
)

export default component.exports